import { lazy } from 'react';

const AdminPage = lazy(() =>
  import(/* webpackChunkName: "AdminDesktop" */ '@desktop/Admin/AdminPage')
);

export default AdminPage;
